angular.module('tax')
    .component('taxList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/tax/list.html',
        controller: function ($scope, $state, TaxService) {
            this.TaxService = TaxService
            this.reset = () => this.filters = {}

            $scope.$on('tax.updated', () => $state.reload())
        }
    })
